import { Component, OnInit } from '@angular/core';
import { VictorServiceService } from '../apiService/victor-service.service';
import {Router} from '@angular/router';
import { UserLeads } from '../modal/userLeads';
import {throwError} from 'rxjs';
import { Registration } from '../modal/Registration';
import { Faulty } from '../modal/faulty';
import { Company } from '../modal/company';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})

/*

*/
export class MainComponent implements OnInit {
  devices: Registration[];
deviceD: Registration;
sdevice : Registration;
faulty: Faulty[];
loading=false;
companyName;
faultylength;
companies: Company[];
length;
normal_length;
devicetypelength;
public leadsCount: UserLeads;
todayDate;
  constructor(private router: Router, private getCounts: VictorServiceService,private deviceService:VictorServiceService,private dfaulty:VictorServiceService) { 
    if(sessionStorage.getItem('userName')===null){
      console.log('sesson strorage', sessionStorage.getItem('userName'));
      this.router.navigate(['']);
    }
    this.devices = [];
    this.sdevice = new Registration();
    this.leadsCount = new UserLeads;
    if(sessionStorage.getItem('userName')===null){
      this.router.navigate(['']);
    }
    this.todayDate=new Date();
    console.log(this.todayDate)
    this.loading = true;
    this.getCounts.getDetails(sessionStorage.getItem('userName')).subscribe((data: UserLeads) => {
      this.leadsCount = data;
      this.loading=false;
      console.log('LeadsCount',this.leadsCount);
      sessionStorage.setItem('rawLeadsCount', this.leadsCount.rawLeadsCount.toString());
     // console.log(this.leadsCount);
      return true;
    },
    error => {
      this.loading=false;
      console.error("Error in Api!");
      return throwError(error);  // Angular 6/RxJS 6
    }
  );

  this.loading=true;
  this.deviceService.getAllDeviceID().subscribe((data: Registration[])=>{
    this.devices = data;
    this.loading=false;
    this.length= this.devices.length;
    console.log('Deviceid List',this.devices);
    console.log('device length',this.length);
    sessionStorage.setItem('Totaldevice',this.length);
    console.log(sessionStorage.getItem('Totaldevice'))
  }, error=>{
    this.loading=false;
    console.error('Error in get all user api, try again later');
    return throwError(error);
  });
  this.deviceService.getAllDevice().subscribe((data: Registration[])=>{
    this.devices = data;
    this.loading=false;
    this.devicetypelength= this.devices.length;
    console.log('Device Type',this.devices);
    console.log('devicetypelength',this.devicetypelength);
  }, error=>{
    this.loading=false;
    console.error('Error in get all user api, try again later');
    return throwError(error);
  });
  this.deviceService.getfaultyDevice().subscribe((mydata: Faulty[])=>{
    console.log('Working Faulty',mydata)
    this.faulty = mydata;
    this.loading=false;
    this.faultylength= this.faulty.length;
    console.log('faulty List',this.faulty);
    console.log('another',this.faultylength);
    this.normal_length=this.length-this.faultylength;
    console.log('normal',this.normal_length=this.length-this.faultylength);
    
  }, error=>{
    this.loading=false;
    console.error('Error in get all user api, try again later');
    return throwError(error);
  });


  } // end of constructor

  ngOnInit() {
  
    if(sessionStorage.getItem('userName')===null){
      console.log('sesson strorage', sessionStorage.getItem('userName'));
      this.router.navigate(['']);
    }
            

  } // end of ngOnInit
  viewLeadsByStatus(statusId){
    sessionStorage.setItem('statusId',statusId);
    this.router.navigate(['/leads']);
    //return;
   // this.router.navigate(['/dashBoard/leads']);
  } // end of viewDetails
 /*
  viewLeadsByStatus(statusId){
  sessionStorage.setItem('statusId',statusId);
 // sessionStorage.setItem('status','acd');
  this.router.navigate(['/leads']);
    return;
  }  */
  /*superadmin/rawLead*/
  navigateLead(path){
    this.router.navigateByUrl(path);
  }
  



}
